import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { HttpUtils } from '../../../../common/http/http-utils';
import { HttpClient } from '@angular/common/http';

export interface SupportData {
    buildVersion: string;
    systemID: string;
    techSupportLink: string;
}

@Injectable()
export class SupportService {
    private localSitesPromise: any = null;

    private _supportData$: Subject<SupportData[]>;
    private dataStore: {
        supportData: SupportData[]
    };

    // tslint:disable-next-line:member-ordering
    private baseUrl;
    private localHcspEndpoints: any = null;
    private requestHeaders = null;
    private devHmToken: string = null;

    constructor(public http: HttpClient) {
        this.dataStore = { supportData: [] };
        this._supportData$ = new Subject() as Subject<SupportData[]>;
        const path = (window.location.pathname.match(/(.*)(\/hcx)(\/.*|$)/) || [])[1];
        this.baseUrl = !!path ? path + '/hcx-ui/rest' : '';
        this.devHmToken = this.findGetParameter('devHmToken');
        this.requestHeaders = new Headers();
        this.requestHeaders.append('Accept', 'application/json');
        this.requestHeaders.append('Content-Type', 'application/json');
        // tslint:disable-next-line:no-unused-expression
        !!this.devHmToken && this.requestHeaders.append('x-hm-authorization', this.devHmToken);
    }

    get supportData() {
        return this._supportData$.asObservable();
    }

    loadSupportInfo(vcGuid) {
        const url = HttpUtils.getBaseUrl() + '/hybridity/api/systemDetails?vcGuid=' + vcGuid;
        this.http.get(url, { headers: this.requestHeaders })
            .map(
                (response:any) => response).subscribe((data) => {
            // store in data store
            this.dataStore.supportData = data;
            // update service instances array from data store
            this._supportData$.next(this.dataStore.supportData);
        }, (error) => {
            this.dataStore.supportData = [];
            this._supportData$.next(this.dataStore.supportData);
            console.log('Could not load support data instances.');
        });
    }

    public getContext(force = false) {
        const me = this;
        if (!me.localSitesPromise || force) {
            me.localSitesPromise = me.http.get(me.baseUrl + '/hybridity/api/metainfo/context/support', { headers: me.requestHeaders })
                .map((response:any) => response).toPromise().then( (resp) => {
                    me.localHcspEndpoints = [];
                    resp.data.localEndpoints.forEach((localEndpoint) => {
                        if (localEndpoint.hcsp && localEndpoint.hcsp.uuid) {
                            me.localHcspEndpoints.push(localEndpoint);
                            localEndpoint.hcsp.resourceName = localEndpoint.resourceName; // XXX this is speculation
                        }
                    });
                    return me.localHcspEndpoints;
                });
        }
        return me.localSitesPromise;
    }

    private findGetParameter(parameterName) {
        // tslint:disable-next-line:one-variable-per-declaration
        let result = null, tmp = [];
        location.search.substr(1).split('&').forEach((item) => {
            tmp = item.split('=');
            if (tmp[0] === parameterName) { result = decodeURIComponent(tmp[1]); }
        });
        return result;
    }

    public pollOvaBundleDownloadStatus(downloadId) {
        const me = this;
        const jobStatusUrl = this.baseUrl + '/hybridity/api/downloads/' + downloadId;
        return Observable.interval(10000)
            .switchMap(() => this.http.get(jobStatusUrl, { headers: me.requestHeaders }))
            .map((response) => response)
            .catch((error) => {
                return Observable.throw(error);
            });
    }

    // get the downloadID for OVA file
    public downloadOvaBundleFile() {
        const me = this;
        const url = this.baseUrl + '/hybridity/api/downloads';

        const payload = {
            bundleType: 'HCX Enterprise',
            fileType: 'ova'
        };
        return this.http.post(url, JSON.stringify(payload), {headers: me.requestHeaders})
        .catch((error) => {
            return Observable.throw(error);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/support/support.service.ts